import React, { FC, useEffect, useState } from 'react';
import { Modal as AntModal, Row, Tooltip } from 'antd';
import { api } from '../../../api/api';
import { Coach, CoachMembershipDto } from '../../../types/userTypes';
import { StyledAntTable } from '../table/Table.style';
import { copyToClipboard, notify } from '../../../utils/helpers';
import { CopyOutlined } from '@ant-design/icons';

const columns = [
  {
    title: "",
    dataIndex: 'id',
    width: '0%',
    render: value => ''
  },
  {
    title: "Organization Name",
    dataIndex: 'organizationName',
    width: '40%'
  },
  {
    title: "Role",
    dataIndex: 'role',
    width: '30%'
  },
  {
    title: "Access Code",
    dataIndex: 'accessCode',
    width: '30%',
    render: value => (
      <Row>
        <span style={{ marginRight: '4px' }}>{value}</span>
        <Tooltip title="Copy access code">
          <CopyOutlined onClick={() => copyToClipboard(value)} />
        </Tooltip>
      </Row>
    )
  }
];

type Props = {
  coach?: Coach;
  onClose: () => void;
};

const CoachMembershipsModal: FC<Props> = ({ coach, onClose }: Props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<CoachMembershipDto[]>();

  useEffect(() => {
    if (coach) {
      getCoachMemberships(coach.id);
    }
  }, [coach])

  const getCoachMemberships = async (id: number) => {
    setLoading(true);
    const response = await api.getCoachMemberships(id!);
    setLoading(false);
    if (!response.ok) {
      notify('Something went wrong');
      return;
    }
    setData(response.data);
  }

  const renderContent = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <StyledAntTable
          columns={columns}
          rowKey={record => record['id']}
          dataSource={data}
          loading={loading}
          pagination={false}
        />
      </div>
    );
  }

  return (
    <AntModal
      title={''}
      visible={!!coach}
      footer={null}
      onCancel={() => onClose()}
    >
      {!!coach && renderContent()}
    </AntModal>
  );
};

export default CoachMembershipsModal;
